import { fetchRegions, fetchLanguages } from "@/api/landing";

function withLoading(commit, action, loadingMutation) {
  commit(loadingMutation, true);
  return action()
    .catch((error) => {
      console.error("Ошибка:", error);
      throw error;
    })
    .finally(() => commit(loadingMutation, false));
}

export default {
  namespaced: true,
  state: {
    regions: [],
    languages: [],
    languagesLoading: false,
    regionsLoading: false,
  },
  mutations: {
    SET_REGIONS(state, regions) {
      state.regions = regions;
    },
    SET_LANGUAGES(state, languages) {
      state.languages = languages[1].children;
    },
    SET_LANGUAGES_LOADING(state, loading) {
      state.languagesLoading = loading;
    },
    SET_REGIONS_LOADING(state, loading) {
      state.regionsLoading = loading;
    },
  },
  actions: {
    async loadRegions({ dispatch, state }) {
      if (state.regions && state.regions.length > 0) return;
      return dispatch("loadData", {
        mutation: "SET_REGIONS",
        fetchFn: fetchRegions,
        loadingMutation: "SET_REGIONS_LOADING",
      });
    },
    async loadLanguages({ dispatch, state }) {
      if (state.languages && state.languages.length > 0) return;
      return dispatch("loadData", {
        mutation: "SET_LANGUAGES",
        fetchFn: fetchLanguages,
        loadingMutation: "SET_LANGUAGES_LOADING",
      });
    },
    async loadData({ commit }, { mutation, fetchFn, loadingMutation }) {
      return withLoading(
        commit,
        async () => {
          const response = await fetchFn();
          commit(mutation, response.data);
        },
        loadingMutation
      );
    },
  },
  getters: {
    getRegions: (state) => state.regions,
    getLanguages: (state) => state.languages,
    isLanguagesLoading: (state) => state.languagesLoading,
    isRegionsLoading: (state) => state.regionsLoading,
  },
};
